import styled, {keyframes, css} from 'styled-components'

const slideIn = keyframes`
  from {
    transform: translateX(-100%);
  }
  to {
    transform: translateX(0);
  }
`

const slideOut = keyframes`
  from {
    transform: translateX(0);
  }
  to {
    transform: translateX(100%);
  }
`

export const SideBarContainer = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  position: fixed;
  top: 70px;
  bottom: 0px;
  background-color: ${props => (props.theme === true ? '#212121' : '#f9f9f9')};
  width: 270px;
  padding-top: 20px;

  @media screen and (max-width: 767px) {
    display: ${props => (props.isSideBarVisible === true ? 'flex' : 'none')};
    top: 50px;
    height: 100%;
    overflow: scroll;
    width: 50%;
    background-color: ${props =>
      props.theme === true ? '#212121' : '#f9f9f9'};
    padding-bottom: 20px;
    animation: ${props =>
      props.isSideBarVisible === true
        ? css`
            ${slideIn} 0.3s ease-in-out forwards
          `
        : css`
            ${slideOut} 0.3s ease-in-out backwards
          `};
  }
`

export const RoutesContainer = styled.div`
  list-style: none;
  display: flex;
  flex-direction: column;
  list-style-type: none;
  padding: 20px;
  background-color: ${props => (props.theme === true ? '#212121' : '#f9f9f9')};
`

export const RouteItemContainer = styled.div`
  list-style: none;
  display: flex;
  flex-direction: row;
  align-items: center;
  background-color: ${props => (props.select === true ? '#3b82f6' : 'inherit')};
  width: 100%;
  height: 42px;
  padding: 1px;
  margin: 2px;
  padding-left: 18px;
`
export const Icons = styled.i`
  color: ${props => {
    if (props.select === true) {
      return '#ff0000'
    }
    if (props.theme === true) {
      return '#ffffff'
    }
    return '#383838'
  }};
`

export const RouteName = styled.p`
  font-size: 18px;
  font-family: 'Roboto';
  color: ${props => (props.theme === true ? '#ffffff' : '#383838')};
  font-weight: ${props => (props.select === true ? 700 : 500)};
  margin-left: 12px;
`

export const ContactUsContainer = styled.div`
  display: flex;
  flex-direction: column;
  padding: 20px;
`
export const AppsIconsContainer = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 14px;
`

export const AppIcon = styled.img`
  height: 35px;
  width: 35px;
`
export const Heading = styled.p`
  font-family: 'Roboto';
  font-size: 22px;
  font-weight: 600;
  margin-bottom: 20px;
  color: ${props => (props.theme === true ? '#ffffff' : '#383838')};
`

export const Para = styled.p`
  font-family: 'Roboto';
  font-size: 14px;
  color: ${props => (props.theme === true ? '#ffffff' : '#383838')};
`
export const LinkEl = styled.a`
  text-decoration: none;
`
